import React from "react";
import Helmet from "react-helmet";
import "../assets/css/App.css";
import "../assets/css/index.css";
import { Button, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import Img from "gatsby-image";
import SEO from "../components/SEO";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import PlantRoomExamples from "../components/PlantRoomExamples";
import { ProjectsBlock } from "../components/ProjectsBlock";

const StyledButton = styled(Button)`
  & {
    margin: 0;
  }
`;

export default ({ data }) => (
  <Layout>
    <SEO
      title="Recently Completed Projects by"
      description="BBIS Heating have completed projects on some of the United Kingdom prised houses, working on commercial boiler service and domestic heating maintenance"
      keywords=""
    />
    <div className="white-segment">
      <h1 class="heading-color">
        Commercial Heating Case Studies
      </h1>
      <p>We’ve carried out a range of commercial heating projects, from plant rooms in large apartment buildings to underfloor heating in golf clubs. Read more about these projects and see the transformation here.</p>
      <ProjectsBlock></ProjectsBlock>
    </div>

    <div class="white-segment text-left">
      <h3 class="sub-heading heading-color pb-2" id="wrothampark">Wrotham Park</h3>
      <Row>
        <Col lg>
          <Img
            fluid={data.wrothampark.childImageSharp.fluid}
            className="pb-4 mx-auto d-block img-fluid"
            alt="BBIS-Wrotham-park"
          />
          <h4 class="sub-heading pt-4">Project details</h4>
          <p>
            Decommissioning and removal of redundant boiler plant, pipework &
            redundant plant within existing boiler room Installation of 3 new
            condensing boilers c/w fully modulating burners for use with natural
            gas. Pipework insulation within boiler room. Automatic controls and
            control/distribution panel including distribution, switches, lamps,
            detectors and equipment control valves. Installation of 2 stainless
            steel calorifiers. Painting of plantroom
          </p>
        </Col>
      </Row>
    </div>
    <div class="white-segment text-left">
      <h3 class="sub-heading heading-color pb-2" id="londonW1">London W1</h3>
      <Row>
        <Col md>
          <Img
            fluid={data.london1.childImageSharp.fluid}
            alt="BBIS-Wrotham-park"
            className="pb-4 mx-auto d-block img-fluid"
          />
        </Col>
        <Col md>
          <Img
            fluid={data.london2.childImageSharp.fluid}
            alt="BBIS-Wrotham-park"
            className="pb-4 mx-auto d-block img-fluid"
          />
        </Col>
      </Row>
      <Row>
        <Col lg>
          <h4 class="sub-heading pt-4">Project details</h4>
          <p>
            This project involved among other things; the removal of two ageing
            boilers and cleaning of the boiler room, new boilers installed and a
            sealed system conversion. The design and fabrication of new
            pipework, a new custom built electrical control panel. Power
            flushing of the entire heating system, dosing of the system with
            inhibitor.
          </p>
          <p>
            The system was commissioned and is now running quieter, more
            efficiently and with greatly improved flow around the building.
          </p>
        </Col>
      </Row>
    </div>
    <div class="grey-segment text-left">
      <h3 class="sub-heading heading-color pb-2" id="chancellorsschool">Chancellors School</h3>
      <Row>
        <Col lg>
          <h4 class="sub-heading pt-4">Project details</h4>
          <p>
            A service visit comprising of 3 boiler rooms, 3 gas meters and their
            pipework which has to be tested and certificated.
          </p>
          <p>
            A gym hall with radiant overhead gas heaters and various gas
            appliances. There are also 2 gas fired water heaters, expansion
            vessels, pressurisation unit, and various pumps which are all
            maintained by ourselves.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md>
          <Img
            fluid={data.cs1.childImageSharp.fluid}
            alt="BBIS-Wrotham-park"
            className="pb-4 mx-auto d-block img-fluid"
          />
        </Col>
        <Col md>
          <Img
            fluid={data.cs2.childImageSharp.fluid}
            alt="BBIS-Wrotham-park"
            className="pb-4 mx-auto d-block img-fluid"
          />
        </Col>
      </Row>

    </div>
    <div class="grey-segment text-left">
      <h3 class="sub-heading heading-color pb-2" id="essendoncountryclub">Essendon Country Club</h3>
      <Row>
        <Col lg>
          <Img
            fluid={data.ecc.childImageSharp.fluid}
            alt="BBIS-Wrotham-park"
            className="pb-4 mx-auto d-block img-fluid"
          />
          <h4 class="sub-heading ">Project details</h4>
          <p>
            This project involved laying underfloor heating for the clubhouse
            extension. The heat is supplied to the room via approximately 700
            meters of pipes buried under a concrete screed.
          </p>
          <p>
            The pipes are fed from a manifold which in turn is supplied from the
            main boilers. The temperature is regulated by a remote room
            thermostat linked to a pump and motorised valve.
          </p>
          <p>
            Underfloor heating was used to allow maximum seating capacity
            capacity and less visual impact for the customers at Essendon
            Country Club.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md>
          <Img
            fluid={data.eccb.childImageSharp.fluid}
            alt="BBIS-Wrotham-park"
            className="pb-4 mx-auto d-block img-fluid"
          />
          <h4 class="text-center">During</h4>
        </Col>

        <Col md>
          <Img
            fluid={data.ecca.childImageSharp.fluid}
            alt="BBIS-Wrotham-park"
            className="pb-4 mx-auto d-block img-fluid"
          />
          <h4 class="text-center">After</h4>
        </Col>
      </Row>
    </div>
  </Layout>
);

export const query = graphql`
  query ProjectQueries {
    wrothampark: file(relativePath: { eq: "Projects/wrothampark.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    wimpole: file(relativePath: { eq: "Projects/wimpole.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 1137) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    london1: file(relativePath: { eq: "Projects/london-1.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    london2: file(relativePath: { eq: "Projects/london-2.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    cs1: file(relativePath: { eq: "Projects/cs-1.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    cs2: file(relativePath: { eq: "Projects/cs-2.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portland: file(relativePath: { eq: "Projects/portland.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    ppBefore: file(relativePath: { eq: "Projects/pp-before.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    ppAfter: file(relativePath: { eq: "Projects/pp-after.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    ecc: file(relativePath: { eq: "Projects/ecc.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    eccb: file(relativePath: { eq: "Projects/eccb.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    ecca: file(relativePath: { eq: "Projects/ecca.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandplace86: file(
      relativePath: { eq: "Projects/portlandplace/devonshiresquare.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse1: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse1.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse2: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse2.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse3: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse3.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse4: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse4.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse5: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse5.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse6: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse6.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    newmarblehillhouse50: file(
      relativePath: { eq: "Projects/marblehouse/newmarblehillhouse.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandafter: file(
      relativePath: { eq: "Projects/portlandplace/after.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandafter1: file(
      relativePath: { eq: "Projects/portlandplace/after1.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore: file(
      relativePath: { eq: "Projects/portlandplace/after2.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore1: file(
      relativePath: { eq: "Projects/portlandplace/after4.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore3: file(
      relativePath: { eq: "Projects/portlandplace/after3.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore4: file(
      relativePath: { eq: "Projects/portlandplace/before.jpeg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore5: file(
      relativePath: { eq: "Projects/portlandplace/before2.jpeg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore6: file(
      relativePath: { eq: "Projects/portlandplace/before3.jpeg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore7: file(
      relativePath: { eq: "Projects/portlandplace/before4.jpeg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore8: file(
      relativePath: { eq: "Projects/portlandplace/before5.jpeg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore9: file(
      relativePath: { eq: "Projects/portlandplace/during.jpeg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore10: file(
      relativePath: { eq: "Projects/portlandplace/during1.jpeg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore11: file(
      relativePath: { eq: "Projects/portlandplace/during2.jpeg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    portlandbefore12: file(
      relativePath: { eq: "Projects/portlandplace/temphotwater.jpeg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
  }
`;
